import React, { useEffect, useMemo, useState } from 'react';
import Cookies from 'js-cookie';

const ACCESS_COOKIE = 'test_env_access';
const ACCESS_PARAM = 'test_access';
const COOKIE_DAYS = 180;
const PROD_URL = 'https://www.sofarsounds.com';

const isProtectedHost = (host: string) =>
  host.startsWith('dev.') ||
  host.startsWith('test-1.') ||
  host.startsWith('fanx.') ||
  host.startsWith('visa.');

function getParam(param: string) {
  const url = new URL(window.location.href);
  return url.searchParams.get(param);
}

function stripParam(param: string) {
  const url = new URL(window.location.href);
  url.searchParams.delete(param);
  window.history.replaceState({}, '', url.toString());
}

function redirectToProdPreservingPath() {
  const pathAndQuery = window.location.pathname + window.location.search;
  window.location.replace(`${PROD_URL}${pathAndQuery}`);
}

export default function withTestEnvGate<P extends object>(
  Wrapped: React.ComponentType<P>
) {
  const WithTestEnvGate: React.FC<P> = (props) => {
    const [allowed, setAllowed] = useState(true);

    const shouldGate = useMemo(
      () => isProtectedHost(window.location.hostname),
      []
    );

    useEffect(() => {
      if (!shouldGate) {
        setAllowed(true);
        return;
      }

      const token = getParam(ACCESS_PARAM);

      if (token) {
        stripParam(ACCESS_PARAM);
      }

      const existingCookie = Cookies.get(ACCESS_COOKIE);

      if (existingCookie) {
        setAllowed(true);
        return;
      }

      if (token) {
        Cookies.set(ACCESS_COOKIE, 'true', {
          expires: COOKIE_DAYS,
        });
        setAllowed(true);
        return;
      }

      redirectToProdPreservingPath();
      setAllowed(false);
    }, [shouldGate]);

    if (allowed !== true) {
      return null;
    }

    return <Wrapped {...props} />;
  };

  WithTestEnvGate.displayName = `withTestEnvGate(${
    Wrapped.displayName || Wrapped.name || 'Component'
  })`;

  return WithTestEnvGate;
}
